import styled from "styled-components";
import {BaseContainer} from "../CustomerLayout.styles";

export const SubPageContainer = styled(BaseContainer)``;

export const SubPageContent = styled.div`
    //dimensions
    width: 100%;
    height: 100%;

    //flex
    display: flex;
    flex-direction: column;
    align-items: center;

    z-index: 2;
`;

export const Content = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 35px;
`;

export const PageHeaderRow = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: auto auto auto;
    margin-top: 35px;
`;
